import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

import interactionStore from "@utilifeed/core/stores/interaction.store";
import { useStoreState } from "zustand-x";

export const DialogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dialog] = useStoreState(interactionStore, 'dialog');
  const [inputValue, setInputValue] = useState("");

  const handleClose = () => {
    const state = interactionStore.store.getState();
    state.cancelDialog();
    setInputValue("");
  };

  const handleConfirm = () => {
    const state = interactionStore.store.getState();
    if (dialog?.type === "prompt") {
      state.closeDialog("confirmed", inputValue);
    } else {
      state.closeDialog("confirmed");
    }
    setInputValue("");
  };

  const handleCancel = () => {
    const state = interactionStore.store.getState();
    state.closeDialog("canceled");
    setInputValue("");
  };

  // Reset input value when dialog opens
  React.useEffect(() => {
    if (dialog?.type === "prompt" && dialog.options.defaultInput) {
      setInputValue(dialog.options.defaultInput);
    }
  }, [dialog]);

  return (
    <>
      {children}
      <Dialog
        open={!!dialog}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description"
      >
        {dialog && (
          <>
            <DialogTitle id="dialog-title">{dialog.title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="dialog-description">{dialog.message}</DialogContentText>
              {dialog.type === "prompt" && (
                <TextField
                  autoFocus
                  margin="dense"
                  label={dialog.label || "Input"}
                  type="text"
                  fullWidth
                  variant="outlined"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleConfirm();
                    }
                  }}
                />
              )}
            </DialogContent>
            <DialogActions>
              {dialog.type === "confirm" || dialog.type === "prompt" ? (
                <>
                  <Button onClick={handleCancel} color="inherit">
                    {dialog.options.cancelText || "Cancel"}
                  </Button>
                  <Button onClick={handleConfirm} color="primary" variant="contained">
                    {dialog.options.confirmText || "Confirm"}
                  </Button>
                </>
              ) : (
                <Button onClick={handleConfirm} color="primary" variant="contained">
                  {dialog.options.confirmText || "OK"}
                </Button>
              )}
            </DialogActions>
          </>
        )}
      </Dialog>
    </>
  );
};

